const updates = [
  { time: '2分钟前', text: '某影视公司内部邮件曝光选角潜规则，多位知名演员牵涉其中', tag: '新' },
  { time: '18分钟前', text: '知名美妆博主被质疑产品测评数据造假，品牌方暂停合作', tag: '热' },
  { time: '42分钟前', text: '某综艺节目录制现场发生意外，制片人紧急回应', tag: '新' },
  { time: '1小时前', text: '网上曝光某顶流明星海外资产配置清单真实性待核实', tag: '新' },
  { time: '2小时前', text: '网红夫妻离婚纠纷升级，男方凌晨发长文控诉', tag: '热' },
  { time: '3小时前', text: '某选秀节目人气选手被扒未成年时期争议言论', tag: '新' },
  { time: '4小时前', text: '热门直播间因虚假宣传被市监局开出百万罚单', tag: '热' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">最新动态</h2>
            <p className="text-sm text-foreground-500">实时追踪，分秒必争的吃瓜快讯</p>
          </div>
          <div className="max-w-3xl mx-auto">
            <div className="relative pl-8 before:absolute before:left-[15px] before:top-2 before:bottom-2 before:w-px before:bg-background-300/60">
              {updates.map((item, i) => (
                <div key={i} className="relative mb-6 last:mb-0">
                  <div className={`absolute -left-[29px] top-1 w-3 h-3 rounded-full border-2 ${
                    item.tag === '热' ? 'bg-primary-500 border-primary-500/30' : 'bg-accent-500 border-accent-500/30'
                  }`}></div>
                  <div className="flex items-start gap-3 flex-wrap">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded font-medium whitespace-nowrap ${
                      item.tag === '热' ? 'bg-primary-500/15 text-primary-400' : 'bg-accent-500/15 text-accent-400'
                    }`}>{item.tag}</span>
                    <p className="text-sm text-foreground-700 flex-1 min-w-0">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}